module.exports = __webpack_public_path__ + "img/upload-file-icon.6fc13cf3.svg";